import React from 'react';

const Whatsapp = () => {
  return (
    <a
      href="https://wa.me/5516992282079"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl hover:scale-110 hover:shadow-[0_10px_25px_rgba(37,211,102,0.5)] transition-all duration-300 animate-bounce"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
    >
      <img src="/whatsapp.png" alt="WhatsApp" className="w-10 h-10 object-contain" />
    </a>
  );
};

export default Whatsapp;